import { FC } from "react";
import CookiesPolicys from "@/components/BlankPages/CookiesPolicy";
import Container from "@/components/Container";

// import useMediaQuery from "@/custom_hooks/mediaQuery";
// import cx from 'classnames';

const CookiesPolicy: FC = () => {
  return (
    <div className="flex flex-col bg-white px-4">
      <Container>
        <CookiesPolicys />
      </Container>
    </div>
  );
};
export default CookiesPolicy;
